import { render, staticRenderFns } from "./single_page.vue?vue&type=template&id=5d99ae2b&scoped=true&"
import script from "./single_page.vue?vue&type=script&lang=js&"
export * from "./single_page.vue?vue&type=script&lang=js&"
import style0 from "./single_page.vue?vue&type=style&index=0&id=5d99ae2b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d99ae2b",
  null
  
)

export default component.exports